import { FlexDiv, FlexRowDiv } from 'components/generic/HomePageComponents'
import { LargeSearchContentContainer } from 'components/Directories/SearchFacetsContainer/Styled'
import ProvidersContainer from 'components/Directories/SearchFacetsContainer/ProvidersContainer'
import FacetsContainer from 'components/Directories/SearchFacetsContainer/FacetsContainer'
import LocationsContainer from 'components/Directories/SearchFacetsContainer/LocationsContainer'
import LanguageDropdown from 'components/Directories/SearchFacetsContainer/LanguageDropdown'
import LargeSearchContainer from './LargeSearchContainer'

const LargeSearchFacetsContainer = ({
  siteDirectoryResultsTypes,
  directoryProvider,
  directoryResultsType,
  providerFacetName,
  providerRadioFacets,
  providerMultiSelectFacets,
  otherFacets,
  selectedFacets,
  directoryLinkInformation,
  keyword,
  locationOptions,
  postalCodeUpdate,
  postalRadiusUpdate,
  invalidPostalCode,
  languages,
  setLanguage,
  selectedLanguageId,
  resetFilters,
  nearestLocation,
}) => {
  const selectedLanguage = languages.find((language) => language.id === selectedLanguageId)
  return (
    <FlexDiv
      mr='25px'
      backgroundColor='#fbfbfb'
      height='fit-content'
      display={{ _: 'none', tablet: 'flex' }}
    >
      <FlexRowDiv justifyContent='space-around' backgroundColor='mainColor' borderRadius='5px'>
        <LargeSearchContentContainer>
          <LargeSearchContainer
            siteDirectoryResultsTypes={siteDirectoryResultsTypes}
            directoryResultsType={directoryResultsType}
            keyword={keyword}
            directoryLinkInformation={directoryLinkInformation}
            resetFilters={resetFilters}
          />
          <LocationsContainer
            locationOptions={locationOptions}
            directoryLinkInformation={directoryLinkInformation}
            postalCodeUpdate={postalCodeUpdate}
            postalRadiusUpdate={postalRadiusUpdate}
            nearestLocation={nearestLocation}
            invalidPostalCode={invalidPostalCode}
          />
          {languages && languages.length > 0 && (
            <LanguageDropdown
              languages={languages}
              setLanguage={setLanguage}
              selectedLanguage={selectedLanguage}
            />
          )}
          <ProvidersContainer
            siteDirectoryResultsTypes={siteDirectoryResultsTypes}
            facetName={providerFacetName}
            providerRadioFacets={providerRadioFacets}
            providerMultiSelectFacets={providerMultiSelectFacets}
            directoryProvider={directoryProvider}
            directoryLinkInformation={directoryLinkInformation}
          />
          <FacetsContainer
            facetGroups={otherFacets}
            selectedFacets={selectedFacets}
            directoryLinkInformation={directoryLinkInformation}
          />
        </LargeSearchContentContainer>
      </FlexRowDiv>
    </FlexDiv>
  )
}

export default LargeSearchFacetsContainer
